import React, { Component } from "react";
import "./transporter-bypass-master.less";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import Select from "react-select";

class AddTransporterBypassMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        transporter_id: this.props.editData ? this.props.editData.transporter_id : "",
        transporter_name: this.props.editData ? this.props.editData.transporter_name : "",
        provider_email: this.props.editData ? this.props.editData.provider_email : "",
        pan_no: this.props.editData ? this.props.editData.pan_no : "",
        is_consignee_review_skip: this.props.editData
          ? !!this.props.editData.is_consignee_review_skip
          : undefined,
        company_id: this.props.editData
          ? this.props.editData.company_id
          : this.props.companyId,
      },
    };
  }

  componentDidMount() {
    setItemToSessionStorage("previousTransporterBypassData", this.props.editData);
  }

  onChangeTransporter = (selectedOption) => {
    let { data } = this.state;
    data.transporter_id = selectedOption.transporter_id;
    data.transporter_name = selectedOption.transporter_name;
    data.provider_email = selectedOption.email;
    data.pan_no = selectedOption.pan_no;
    this.setState({ data });
  };

  onToggleConsigneeReviewSkip = (checked) => {
    let { data } = this.state;
    data.is_consignee_review_skip = checked;
    this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate({
      company_id: data.company_id,
      transporter_id: data.transporter_id,
      is_consignee_review_skip: data.is_consignee_review_skip,
      provider_email: data.provider_email,
      pan_no: data.pan_no,
    });
  };

  render() {
    const { data } = this.state;
    const { editData, transporterOptions } = this.props;

    const disableSave = !(data["transporter_id"] && data["is_consignee_review_skip"] === true);
    const disableUpdate = !data["transporter_id"];

    const options = transporterOptions || [];

    return (
      <div className="tbm-modal-overlay" onClick={this.props.toggleAdd}>
        <div className="tbm-modal" onClick={(e) => e.stopPropagation()}>
          <div className="tbm-modal-header">
            <h2 className="tbm-modal-title">
              {`${editData ? "Edit" : "Add"} POD Consignee Review Skip`}
            </h2>
            <button
              type="button"
              className="tbm-modal-close"
              onClick={this.props.toggleAdd}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          <div className="tbm-modal-body">
            <div className="tbm-field-group">
              <div className="tbm-field">
                <div className="tbm-field-label">
                  Transporter<span className="tbm-required">*</span>
                </div>
                <Select
                  classNamePrefix="tbm-select"
                  className="tbm-select-container"
                  isDisabled={!!editData}
                  options={options}
                  value={options.find(
                    (val) => val.transporter_id == data.transporter_id
                  ) || (editData
                    ? { value: data.transporter_id, label: data.transporter_name }
                    : null)}
                  onChange={this.onChangeTransporter}
                />
              </div>

              {!!data.transporter_id && (
                <div className="tbm-field">
                  <div className="tbm-field-label">Email</div>
                  <div className="tbm-readonly-card">
                    <span className="tbm-readonly-value">{data.provider_email || "-"}</span>
                  </div>
                </div>
              )}

              {!!data.transporter_id && (
                <div className="tbm-field">
                  <div className="tbm-field-label">PAN</div>
                  <div className="tbm-readonly-card">
                    <span className="tbm-readonly-value">{data.pan_no || "-"}</span>
                  </div>
                </div>
              )}

              <div className="tbm-field">
                <div className="tbm-field-label">
                  Consignee Review Skip<span className="tbm-required">*</span>
                </div>
                <div className="tbm-toggle-row">
                  <label className="tbm-toggle">
                    <input
                      type="checkbox"
                      checked={!!data.is_consignee_review_skip}
                      onChange={(e) =>
                        this.onToggleConsigneeReviewSkip(e.target.checked)
                      }
                    />
                    <span className="tbm-toggle-track"></span>
                  </label>
                  <span className="tbm-toggle-text">
                    {data.is_consignee_review_skip ? "Yes" : "No"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="tbm-modal-footer">
            <button
              type="button"
              className="tbm-btn tbm-btn-ghost"
              onClick={this.props.toggleAdd}
            >
              Cancel
            </button>
            {!editData ? (
              <button
                type="button"
                className="tbm-btn tbm-btn-primary"
                onClick={this.onSave}
                disabled={disableSave}
              >
                Save
              </button>
            ) : (
              <button
                type="button"
                className="tbm-btn tbm-btn-primary"
                onClick={this.onUpdate}
                disabled={disableUpdate}
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AddTransporterBypassMaster;
